// /src/pages/private/members/academyTools/components/MemberAcademyDocumentPanel.jsx

import React from 'react';
import PrivateLexicalPage from '../../../../../components/PrivateLexicalPage';

export default function MemberAcademyDocumentPanel({ document }) {
  if (!document?.documentName) return null;

  return (
    <div className="member-academy-document-panel">
      <PrivateLexicalPage
        documentName={document.documentName}
        wrapperClass="member-academy-document-panel__viewer"
        containerClass="member-academy-document-viewer"
        hidePublicToc
        hideReadProgressMeta
      />
    </div>
  );
}
